import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { activityDate2Human } from "../../../utils/dateTime";
import { useDispatch } from "react-redux";
import { activitySet } from "../../../store/activitySlice";
import { useEffect, useState } from "react";
import { del } from "../../../utils/api";
const MAX_ACTIVITIES = 30; // Максимальное число активностей на экспонента
//
// Компонент для отображения списка активностей экспонента
//
const ActivityList = ({ exhibitor }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language === 'en' ? 'en' : 'ru';
	const navigate = useNavigate();
    const dispatch = useDispatch();
    const [ activities, setActivities ] = useState([]);
    const [ error, setError ] = useState('');
    const [ isLoading, setIsLoading ] = useState(false);

    useEffect(() => {
        if(Array.isArray(exhibitor.activities)) {
            setActivities(exhibitor.activities);
        } else {
            setActivities([]);
        }
    }, [ exhibitor ]);

    const onClick = (activity) => {
        dispatch(activitySet(activity));
        navigate('/cabinet/activityedit/');
    };

    const onRemove = async (activity) => {
        if(!window.confirm(t('exhibitorview.activity_confirm'))) return;
        setIsLoading(true);
        setError('');
        const result = await del(`/activities/${activity._id}`);
        if(result.error) {
            setError(t(result.error));
        } else {
            let newActivities = [...activities];
            let index = newActivities.findIndex(a => a._id === result.data.activity._id);
            if(index >= 0) newActivities.splice(index, 1);
			setActivities(newActivities);
        }
        setIsLoading(false);
    };

    return (
	<div>
        <h2>
            {t('exhibitorview.activities')}
            {activities.length < MAX_ACTIVITIES && <span onClick={() => navigate('/cabinet/activityadd')}>{t('common.add')}</span>}
        </h2>
        {error && <div className='error'>{error}</div>}
        {isLoading && <div className='success'>{t('common.loading')}</div>}
        {activities.length
        ? <ul>
            {[...activities].sort((a, b) => a.date.localeCompare(b.date)).map(activity => (
                <li
                    key={activity._id}
                >
                    <span
                        className='a'
                        onClick={() => onClick(activity)}
                    >
                        {activity.name[lang]}
                    </span><br/>
                    <span
                        className='small gray'
                    >
                        {activityDate2Human(activity.date, lang)}
                    </span>&nbsp;
                    {!isLoading && <span className='a small' onClick={() => onRemove(activity)}>{t('common.remove')}</span>}
                </li>
            ))}
        </ul>
        : <div>{t('exhibitorview.noactivities')}</div>}
    </div>
	);
};

export default ActivityList;
